import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Nav, NavItem, NavLink, UncontrolledTooltip } from 'reactstrap'
import PropTypes from 'prop-types'
import { AppNavbarBrand, AppSidebarToggler } from '@coreui/react'
import logo from '../../assets/img/brand/conway_claim_small.jpg'
import logosmall from '../../assets/img/brand/logo-small.png'
import { getSystemConfig } from '../../services/session/systemConfig'
import {
  getCurrentAccount,
  getCurrentFullViewState,
  setCurrentAccount
} from '../../services/session/sessionState'
import 'react-toastify/dist/ReactToastify.min.css'
import axios from 'axios'
import { Phone } from '../../components/Header/Phone'
import { Whatsapp } from '../../components/Header/Whatsapp'
import { Notifications } from '../../components/Header/Notifications'
import { UserMenu } from '../../components/Header/UserMenu'
import ShoppingCart from '../../components/Header/ShoppingCart'
import { OrderTrackingIndicator } from '../../components/OrderTracking/OrderTrackingIndicator'
import { OrderTrackingContext } from '../../context/orderTracking.context'
import { getWebOrderStatus } from '../../common/webOrderStatus'
import { conwayTransValidValues } from '../../constants/Orders'

const DefaultHeader = () => {
  const history = useHistory()

  const orderTrackingContext = useContext(OrderTrackingContext)

  const tickIntervalRef = useRef()
  const notificationsIntervalRef = useRef()

  const [webOrderStatus, setWebOrderStatus] = useState(null)
  const [customer, setCustomer] = useState({ name: 'Seleccionar punto de venta' })
  const [systemConfig, setSystemConfig] = useState(getSystemConfig())
  const [downloadingLogo, setDownloadingLogo] = useState(false)
  const [notifications, setNotifications] = useState([])
  const [isFullViews, setIsFullViews] = useState(getCurrentFullViewState())

  const getUnreadNotifications = useCallback(() => {
    if (customer && customer.id) {
      axios
        .post(process.env.REACT_APP_API_URL + '/api/Notifications/GetUnreadNotifications/', {
          customerId: customer.id
        })
        .then(({ data }) => {
          if (data.isError) {
            console.error(data.message)
          } else {
            setNotifications(data.data)
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    }
  })

  const tick = useCallback(async () => {
    let currentAccount = getCurrentAccount()

    if (currentAccount !== null && currentAccount.id !== customer.id) {
      if (currentAccount.base64Logo === null && downloadingLogo === false) {
        setDownloadingLogo(true)
        var url =
          process.env.REACT_APP_API_URL + '/api/Filesystem/Logos/' + currentAccount.external_Id__c
        const { data } = await axios.get(url)
        if (data.isError) {
          console.error(data.message)
          return
        }
        const newCustomer = { ...currentAccount, base64Logo: data.data.base64 }
        setCustomer(newCustomer)
        setDownloadingLogo(false)
        setCurrentAccount(newCustomer)
        getUnreadNotifications()
      } else {
        setCustomer(currentAccount)
        getUnreadNotifications()
      }
    }

    if (systemConfig === null && customer !== null) {
      setSystemConfig(getSystemConfig())
    }

    setIsFullViews(getCurrentFullViewState())
  })

  useEffect(() => {
    tickIntervalRef.current = setInterval(() => {
      tick()
    }, 1000)
    notificationsIntervalRef.current = setInterval(() => {
      getUnreadNotifications()
    }, 600 * 1000)
    return () => {
      clearInterval(tickIntervalRef.current)
      clearInterval(notificationsIntervalRef.current)
    }
  }, [])

  useEffect(() => {
    setWebOrderStatus(
      orderTrackingContext && orderTrackingContext.route
        ? getWebOrderStatus(orderTrackingContext.route.orderStatus)
        : null
    )
  }, [orderTrackingContext])

  const handleUpdateAllNotifications = useCallback(() => {
    axios
      .put(process.env.REACT_APP_API_URL + '/api/Notifications/UpdateNotifications/', {
        customerId: customer.id
      })
      .then(({ data }) => {
        if (data.isError) {
          console.error(data.message)
        } else {
          setNotifications([])
        }
      })
      .catch(function (error) {
        console.error(error)
      })
  })

  const handleUpdateNotification = useCallback((id) => {
    axios
      .put(process.env.REACT_APP_API_URL + '/api/Notifications/UpdateNotification/', {
        customerId: customer.id,
        notificationId: id
      })
      .then(({ data }) => {
        if (data.isError) {
          console.error(data.message)
        } else {
          getUnreadNotifications()
        }
      })
      .catch(function (error) {
        console.error(error)
      })
  })

  const showOrderTracking =
    !!customer &&
    customer.securityFlags &&
    customer.securityFlags.showOrderTracking &&
    orderTrackingContext.route &&
    conwayTransValidValues.includes(orderTrackingContext.route.conwayTrans) &&
    customer.mostrarSeccionMisPedidos
  return (
    <React.Fragment>
      <AppSidebarToggler className="d-lg-none" display="md" mobile />
      <AppNavbarBrand
        full={{
          src: logo,
          height: 40,
          alt: 'Conway'
        }}
        minimized={{
          src: logosmall,
          height: 45,
          alt: 'Conway'
        }}
      />
      <AppSidebarToggler className="d-md-down-none" display="lg" />
      <Nav className=" account-selector-text" navbar>
        <NavItem className="">
          <NavLink
            id="accountchangetitle"
            href="#/accountchange"
            data-toggle="tooltip"
            data-placement="right"
            title="Cambio de cuenta"
          >
            <div
              id="wrapper"
              style={{
                height: 'auto',
                display: 'table'
              }}
            >
              <div id="left-div" className="d-sm-down-none">
                {customer && customer.base64Logo && !isFullViews ? (
                  <img
                    id="logo"
                    src={'data:image/jpg;base64,' + customer.base64Logo}
                    alt="Logo"
                    style={{
                      display: 'block',
                      height: '37px',
                      marginRight: '10px'
                    }}
                  />
                ) : null}
              </div>
              <div
                id="right-div"
                style={{
                  display: 'table-cell',
                  verticalAlign: 'middle'
                }}
              >
                {isFullViews
                  ? 'Vistas totalizadas'
                  : customer
                    ? customer.name
                    : 'Seleccionar punto de venta'}
              </div>
            </div>
          </NavLink>
          <UncontrolledTooltip placement="right" target="accountchangetitle">
            Puede cambiar el punto de venta pulsando en el título
          </UncontrolledTooltip>
        </NavItem>
      </Nav>
      <Nav className="ml-auto" navbar>
        {showOrderTracking ? (
          <NavItem className="d-down-none">
            <OrderTrackingIndicator
              id="header-order-tracking"
              webOrderStatus={
                webOrderStatus && webOrderStatus.showInIndicator ? webOrderStatus : null
              }
              orderId={orderTrackingContext.route.orderId}
              showTooltip={true}
            />
          </NavItem>
        ) : null}

        {!customer.activo && !isFullViews && (
          <NavItem>
            <div className="d-flex align-items-center px-3">
              <span
                className="badge bg-danger d-flex align-items-center gap-2"
                style={{
                  fontSize: '0.9rem',
                  padding: '0.5rem 1rem'
                }}
              >
                Cliente Inactivo
              </span>
            </div>
          </NavItem>
        )}

        <Phone phone={customer && customer.telefono_Contacto_Conway__c} />

        <Whatsapp whatsapp={customer && customer.whatsappContactoConway__c} />

        {!history.location.pathname.includes('/accountchange') &&
          !history.location.pathname.includes('/checkout') &&
          customer.mostrarSeccionMisProductos &&
          !isFullViews &&
          !!customer &&
          customer.activo &&
          customer.securityFlags &&
          customer.securityFlags.createOrders && (
            <ShoppingCart
              showMoney={customer && customer.securityFlags && customer.securityFlags.showMoney}
            />
          )}

        {!history.location.pathname.includes('/accountchange') && (
          <Notifications
            notifications={notifications}
            onReadAll={handleUpdateAllNotifications}
            onRead={handleUpdateNotification}
          />
        )}

        <UserMenu />
      </Nav>
    </React.Fragment>
  )
}

DefaultHeader.propTypes = {
  children: PropTypes.node
}
DefaultHeader.defaultProps = {}
DefaultHeader.displayName = 'DefaultHeader'

export default DefaultHeader
